import {doNotTrack} from "../consts";
import {testIsValidUser, Raven} from "../util";

const thirdParties = [];

export function callThirdParties(trackData) {
	try{
		if(doNotTrack){
			return function (trackData) {}
		}else if(!testIsValidUser()){
			return function (trackData) {
				console.log('Internal User, not sent', trackData)
			}
		}else{
			thirdParties.forEach(function (trackPlugin) {
				if(trackPlugin instanceof TrackPlugin) {
					if(trackPlugin.beforeTrackFilter(trackData)) {
						if(trackPlugin.inited) {
							trackPlugin.sendTrack(trackData);
						} else {
							console.warn(`trackPlugin ${trackPlugin.pluginName} not inited!`);
							trackPlugin.unsendTrackData.add(trackData);
						}
					}
				}
			})
		}
	}catch (err){
		console.error(err);
	}
}

export default class TrackPlugin {

	static get Raven() {
		return Raven
	}

	static get plugins() {
		return thirdParties;
	}

	constructor(pluginName) {
		this.pluginName = pluginName;
		this.inited = false;
		this.unsendTrackData = new Set();
		thirdParties.push(this)
	}

	get allowInit() {
		return testIsValidUser()
	}

	// overwrite
	init() {
		if(!this.allowInit) {
			return
		}
		this.inited = true;
		this.unsendTrackData.forEach((trackData) => {
			if(this.beforeTrackFilter(trackData)) {
				this.sendTrack(trackData);
			}
		});
		this.unsendTrackData.clear();
	}

	// overwrite
	beforeTrackFilter(trackData) {
		return true;
	}

	// overwrite
	sendTrack(trackData) {
		console.warn(`Empty sendTrack, need overwrite`)
	}
}
